// extracted by mini-css-extract-plugin
export default {"fv_area":"NotFound_fv_area__3iBiM","content":"NotFound_content__X9rZ7","button":"NotFound_button__sCTN5"};